<template>
  <div :class="scope.clsPrefix">
    <div class="list-container">
      <div class="main-content">
        <div class="header-tabs">
          <div
            class="tab"
            :class="{ active: activeTab === 'history' }"
            @click="
              activeTab = 'history';
              editMode = false;
            "
          >
            任务历史
          </div>
          <div
            class="tab"
            :class="{ active: activeTab === 'config' }"
            @click="activeTab = 'config'"
          >
            任务配置
          </div>
        </div>
        <div v-if="activeTab !== 'history'" class="tabs_split"></div>
        <div class="search-container" v-if="activeTab === 'history' && !editMode">
          <div class="search-area" v-if="!editMode">
            <el-input
              size="small"
              placeholder="搜索任务标题..."
              v-model="searchText"
              class="search-input"
            ></el-input>
            <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="filter-bar">
            <div class="filter-group">
              <span class="filter-label">状态：</span>
              <div class="filter-tabs">
                <div
                  class="filter-tab"
                  :class="{ active: activeStatus === 'all' }"
                  @click="activeStatus = 'all'"
                >
                  全部
                </div>
                <div
                  class="filter-tab"
                  :class="{ active: activeStatus === 'running' }"
                  @click="activeStatus = 'running'"
                >
                  执行中
                </div>
                <div
                  class="filter-tab"
                  :class="{ active: activeStatus === 'pending' }"
                  @click="activeStatus = 'pending'"
                >
                  失败
                </div>
                <div
                  class="filter-tab"
                  :class="{ active: activeStatus === 'completed' }"
                  @click="activeStatus = 'completed'"
                >
                  已完成
                </div>
              </div>
            </div>
            <!-- <div class="filter-group">
            <span class="filter-label">执行者：</span>
            <div class="filter-tabs">
              <div class="filter-tab" :class="{ active: activeExecutor === 'all' }" @click="handleExecutorChange('all')">全部</div>
              <div v-for="executor in executorList" :key="executor.key" class="filter-tab" :class="{ active: activeExecutor === executor.key }" @click="handleExecutorChange(executor.key)">
                {{ executor.name }}
              </div>
            </div>
          </div> -->
          </div>
        </div>
        <div class="edit-panel" v-if="editMode">
          <div class="edit-header">
            <div class="edit-title">
              {{ editForm.id ? "编辑任务配置" : "新建任务配置" }}
            </div>
            <div class="edit-close" @click="editMode = false">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="edit-form">
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>任务标题</label>
              <el-input
                v-model="editForm.title"
                placeholder="请输入任务标题"
                size="medium"
                class="form-input"
              ></el-input>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>执行者</label>
              <el-select
                v-model="editForm.agent"
                placeholder="请选择执行者"
                size="medium"
                class="form-select"
                disabled
              >
                <el-option
                  v-for="executor in executorList"
                  :key="executor.key"
                  :label="executor.name"
                  :value="executor.name"
                ></el-option>
              </el-select>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>任务类型</label>
              <el-select
                v-model="editForm.taskType"
                placeholder="请选择任务类型"
                size="medium"
                class="form-select"
              >
                <el-option label="文字消息" value="text"></el-option>
                <el-option label="报告" value="report"></el-option>
                <el-option label="提醒" value="reminder"></el-option>
              </el-select>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>报告类型</label>
              <el-radio-group v-model="editForm.reportType">
                <el-radio label="market">市场行情</el-radio>
                <el-radio label="competitor">竞品动态</el-radio>
                <el-radio label="policy">政策法规</el-radio>
              </el-radio-group>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>报告类别</label>
              <el-radio-group v-model="editForm.category">
                <el-radio label="internal">经营报告</el-radio>
                <el-radio label="external">咨询报告</el-radio>
              </el-radio-group>
            </div>
            <div class="form-item">
              <el-checkbox v-model="editForm.decision">生成待办</el-checkbox>
            </div>
            <div class="form-item" v-if="editForm.decision">
              <label class="form-label">生成待办的条件或指令</label>
              <el-input
                type="textarea"
                v-model="editForm.decisionCondition"
                placeholder="输入异常识别规则，当报告数据触发以下条件时自动创建待办事项..."
                :rows="3"
                class="form-textarea"
              ></el-input>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>报告周期</label>
              <div class="form-radio-group">
                <label v-for="p in periodOptions" :key="p.value" class="form-radio-item">
                  <input
                    type="radio"
                    v-model="cronPeriod"
                    :value="p.value"
                    class="form-radio"
                    @change="onCronPeriodChange"
                  />
                  <span class="form-radio-label">{{ p.label }}</span>
                </label>
              </div>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>执行时间</label>
              <div v-if="cronPeriod === 'daily'" class="cron-selects">
                <span class="cron-select-label">每天</span>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option
                    v-for="h in 24"
                    :key="h - 1"
                    :label="(h - 1).toString().padStart(2, '0') + ' 时'"
                    :value="h - 1"
                  />
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option
                    v-for="m in cronMinuteOptions"
                    :key="m"
                    :label="m.toString().padStart(2, '0') + ' 分'"
                    :value="m"
                  />
                </el-select>
              </div>
              <div v-else-if="cronPeriod === 'monthly'" class="cron-selects">
                <span class="cron-select-label">每月</span>
                <el-select v-model="cronMonthDay" class="cron-sel" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d" />
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option
                    v-for="h in 24"
                    :key="h - 1"
                    :label="(h - 1).toString().padStart(2, '0') + ' 时'"
                    :value="h - 1"
                  />
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option
                    v-for="m in cronMinuteOptions"
                    :key="m"
                    :label="m.toString().padStart(2, '0') + ' 分'"
                    :value="m"
                  />
                </el-select>
              </div>
              <div v-else-if="cronPeriod === 'quarterly'" class="cron-selects">
                <span class="cron-select-label">每季度第</span>
                <el-select
                  v-model="cronQuarterStart"
                  class="cron-sel"
                  placeholder="起始月"
                >
                  <el-option
                    v-for="q in quarterOptions"
                    :key="q.value"
                    :label="q.label"
                    :value="q.value"
                  />
                </el-select>
                <el-select v-model="cronMonthDay" class="cron-sel" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d" />
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option
                    v-for="h in 24"
                    :key="h - 1"
                    :label="(h - 1).toString().padStart(2, '0') + ' 时'"
                    :value="h - 1"
                  />
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option
                    v-for="m in cronMinuteOptions"
                    :key="m"
                    :label="m.toString().padStart(2, '0') + ' 分'"
                    :value="m"
                  />
                </el-select>
              </div>
              <div v-else-if="cronPeriod === 'yearly'" class="cron-selects">
                <span class="cron-select-label">每年</span>
                <el-select v-model="cronMonth" class="cron-sel" placeholder="月">
                  <el-option v-for="mo in 12" :key="mo" :label="mo + ' 月'" :value="mo" />
                </el-select>
                <el-select v-model="cronMonthDay" class="cron-sel" placeholder="日">
                  <el-option v-for="d in 28" :key="d" :label="d + ' 日'" :value="d" />
                </el-select>
                <el-select v-model="cronHour" class="cron-sel" placeholder="时">
                  <el-option
                    v-for="h in 24"
                    :key="h - 1"
                    :label="(h - 1).toString().padStart(2, '0') + ' 时'"
                    :value="h - 1"
                  />
                </el-select>
                <span class="cron-select-sep">:</span>
                <el-select v-model="cronMinute" class="cron-sel" placeholder="分">
                  <el-option
                    v-for="m in cronMinuteOptions"
                    :key="m"
                    :label="m.toString().padStart(2, '0') + ' 分'"
                    :value="m"
                  />
                </el-select>
              </div>
              <div class="cron-preview">
                <span class="cron-preview-label">Cron 表达式：</span>
                <code class="cron-preview-value">{{ computedCronExpression }}</code>
              </div>
            </div>
            <div class="form-item">
              <label class="form-label">是否启用</label>
              <el-switch
                v-model="editForm.enabled"
                active-text="启用"
                inactive-text="禁用"
              ></el-switch>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>来源</label>
              <el-select
                v-model="editForm.source"
                placeholder="请选择来源"
                size="medium"
                class="form-select"
              >
                <el-option label="手动" value="manual"></el-option>
                <el-option label="决策智能体" value="decision"></el-option>
                <el-option label="对话" value="conversation"></el-option>
              </el-select>
            </div>
            <div class="form-item">
              <label class="form-label"><span class="required">*</span>任务内容</label>
              <el-input
                type="textarea"
                v-model="editForm.content"
                placeholder="请输入任务内容"
                :rows="4"
                class="form-textarea"
              ></el-input>
            </div>
            <div class="form-actions">
              <el-button type="primary" @click="handleSave">保存</el-button>
              <el-button @click="editMode = false">取消</el-button>
            </div>
          </div>
        </div>
        <div class="task-list history-list" v-if="activeTab === 'history' && !editMode">
          <template v-if="filteredTasks.length > 0">
            <div
              v-for="(task, index) in filteredTasks"
              :key="index"
              class="task-item history-item"
            >
              <div class="history-card-header" @click="handleToggleExpand(index)">
                <div class="history-card-left">
                  <div class="task-icon-wrap" :class="task.iconClass">
                    <i class="el-icon-s-data" v-if="task.type === 'indicator'"></i>
                    <i
                      class="el-icon-connection"
                      v-else-if="task.type === 'governance'"
                    ></i>
                    <i class="el-icon-s-home" v-else-if="task.type === 'decision'"></i>
                    <i class="el-icon-user" v-else></i>
                  </div>
                  <div class="task-info">
                    <div class="task-title">{{ task.title }}</div>
                    <div class="task-desc">{{ task.desc }}</div>
                  </div>
                </div>
                <div class="history-card-right">
                  <div class="task-status" :class="task.statusClass">
                    {{ task.status }}
                  </div>
                  <span
                    class="expand-icon"
                    :class="{ expanded: expandedIndexes.includes(index) }"
                  >
                    <i class="el-icon-arrow-down"></i>
                  </span>
                </div>
              </div>
              <div class="history-card-content" v-if="expandedIndexes.includes(index)">
                <div class="content-row">
                  <span class="row-label">任务内容：</span>
                  <span class="row-value">{{ task.desc }}</span>
                </div>
                <div class="content-row">
                  <span class="row-label">开始时间：</span>
                  <span class="row-value">{{ task.startedAt }}</span>
                </div>
                <div class="content-row">
                  <span class="row-label">结束时间：</span>
                  <span class="row-value">{{ task.finishedAt }}</span>
                </div>
                <div class="content-row">
                  <span class="row-label">执行者：</span>
                  <span class="row-value">{{ task.agent }}</span>
                </div>
                <div v-if="task.status === '已完成'" class="action-btn primary" @click.stop="handleViewDetail(task)">
                  查看完整报告
                </div>
              </div>
            </div>
          </template>
          <div v-else class="empty-state">暂无数据</div>
        </div>
        <div class="task-list config-list" v-if="activeTab === 'config' && !editMode">
          <div class="config-header">
            <span class="config-count">共 {{ configTasks.length }} 个任务配置</span>
            <button class="add-task-btn" @click="handleAddTask">新建任务</button>
          </div>
          <template v-if="configTasks.length > 0">
            <div
              v-for="(task, index) in configTasks"
              :key="index"
              class="task-item config-item"
            >
              <div class="config-info">
                <div class="config-title">{{ task.title }}</div>
                <div class="config-meta">
                  <span>{{ task.agent }}</span>
                  <span>上次完成：{{ task.lastTime }}</span>
                  <span>下次执行：{{ task.nextTime }}</span>
                </div>
              </div>
              <div class="config-status" :class="task.statusClass">{{ task.status }}</div>
              <div class="config-actions">
                <span class="config-action-icon" title="查看" @click="handleView(task)">
                  <i class="el-icon-view"></i>
                </span>
                <span class="config-action-icon" title="编辑" @click="handleEdit(task)">
                  <i class="el-icon-edit"></i>
                </span>
                <span class="config-action-icon" title="删除" @click="handleDelete(task)">
                  <i class="el-icon-delete"></i>
                </span>
                <span class="config-action-icon" title="立即执行" :class="{ 'config-action-disabled': runningTaskIds.has(task.id) }" @click="runTask(task)">
                  <i class="el-icon-caret-right"></i>
                </span>
                <el-switch
                  v-model="task.enabled"
                  active-color="#4A5FF3"
                  :active-value="true"
                  :inactive-value="false"
                  @change="handleToggle(task)"
                />
              </div>
            </div>
          </template>
          <div v-else class="empty-state">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getJobHistoryListApi,
  getJobListApi,
  createJobApi,
  updateJobApi,
  deleteJobApi,
  getAgentListApi,
  toggleJobApi,
  runJobApi
} from '@/api/agentAuth'
import { AGENT_ID_MAP } from '@/store/modules/cosmoClaw'

export default {
  name: 'TaskList',
  props: {
    agentId: { type: String, default: '' }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-task-list'
      },
      searchText: '',
      activeTab: 'history',
      activeStatus: 'all',
      activeExecutor: 'all',
      editMode: false,
      expandedIndexes: [],
      loading: false,
      agentList: [],
      editForm: {
        id: '',
        title: '',
        agent: '',
        taskType: '',
        cronExpression: '',
        enabled: true,
        content: '',
        source: '',
        reportType: 'market',
        category: 'internal',
        decision: false,
        decisionCondition: ''
      },
      taskList: [],
      configTaskList: [],
      runningTaskIds: new Set(),
      total: 0,
      cronPeriod: 'daily',
      cronMinute: 0,
      cronHour: 9,
      cronMonthDay: 1,
      cronMonth: 1,
      cronQuarterStart: 1,
      periodOptions: [
        { value: 'daily', label: '日报' },
        { value: 'monthly', label: '月报' },
        { value: 'quarterly', label: '季报' },
        { value: 'yearly', label: '年报' }
      ],
      quarterOptions: [
        { value: 1, label: 'Q1(1月)' },
        { value: 4, label: 'Q2(4月)' },
        { value: 7, label: 'Q3(7月)' },
        { value: 10, label: 'Q4(10月)' }
      ],
      cronMinuteOptions: Array.from({ length: 12 }, (_, i) => i * 5)
    }
  },
  computed: {
    executorList() {
      return this.agentList
    },
    filteredTasks() {
      return this.taskList
    },
    configTasks() {
      return this.configTaskList
    },
    computedCronExpression() {
      const m = this.cronMinute
      const h = this.cronHour
      const d = this.cronMonthDay
      switch (this.cronPeriod) {
        case 'daily':
          return `${m} ${h} * * ?`
        case 'monthly':
          return `${m} ${h} ${d} * ?`
        case 'quarterly': {
          const m1 = this.cronQuarterStart
          return `${m} ${h} ${d} ${m1},${m1 + 3},${m1 + 6},${m1 + 9} ?`
        }
        case 'yearly':
          return `${m} ${h} ${d} ${this.cronMonth} ?`
        default:
          return `${m} ${h} * * ?`
      }
    }
  },
  watch: {
    activeTab(val) {
      if (val === 'history') {
        this.fetchJobHistory()
      } else if (val === 'config') {
        this.fetchJobList()
      }
    },
    activeStatus() {
      if (this.activeTab === 'history') {
        this.fetchJobHistory()
      }
    }
  },
  mounted() {
    this.fetchJobHistory()
    this.fetchAgentList()
  },
  methods: {
    async fetchJobHistory() {
      this.loading = true
      try {
        const params = {}
        if (this.searchText) {
          params.jobName = this.searchText
        }
        if (this.activeStatus !== 'all') {
          const statusMap = {
            running: 'running',
            pending: 'failed',
            completed: 'succeeded'
          }
          params.status = statusMap[this.activeStatus]
        }
        const agentId = this.getCurrentAgentId()
        if (agentId) {
          params.agentId = agentId
        }
        if (this.agentId) params.agentId = this.agentId
        const res = await getJobHistoryListApi(params)
        if (res && res.data && res.data.length > 0) {
          this.taskList = this.transformData(res.data)
          this.total = res.data.length || 0
        } else {
          this.taskList = []
          this.total = 0
        }
      } catch (error) {
        console.error('获取任务历史失败:', error)
        this.taskList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    async fetchJobList() {
      this.loading = true
      try {
        const params = {}
        const agentId = this.getCurrentAgentId()
        if (agentId) {
          params.agentId = agentId
        }
        if (this.agentId) params.agentId = this.agentId
        const res = await getJobListApi(params)
        if (res && res.data && res.data.length > 0) {
          this.configTaskList = this.transformConfigData(res.data)
        } else {
          this.configTaskList = []
        }
      } catch (error) {
        console.error('获取任务配置失败:', error)
        this.configTaskList = []
      } finally {
        this.loading = false
      }
    },
    transformConfigData(data) {
      return data.map((item) => {
        let statusText = '已完成'
        let statusClass = 'status-completed'
        let iconClass = 'icon-blue'
        let type = 'ceo'

        if (item.status === 'RUNNING') {
          statusText = '执行中'
          statusClass = 'status-running'
        } else if (item.status === 'PENDING') {
          statusText = '待处理'
          statusClass = 'status-pending'
        }

        if (item.agentName) {
          if (item.agentName.includes('CFO')) {
            iconClass = 'icon-orange'
            type = 'cfo'
          } else if (item.agentName.includes('CSO')) {
            iconClass = 'icon-green'
            type = 'cso'
          } else if (item.agentName.includes('指标')) {
            iconClass = 'icon-blue'
            type = 'indicator'
          } else if (item.agentName.includes('本体')) {
            iconClass = 'icon-blue'
            type = 'governance'
          } else if (item.agentName.includes('决策')) {
            iconClass = 'icon-blue'
            type = 'decision'
          } else {
            iconClass = 'icon-blue'
            type = 'ceo'
          }
        }

        let lastRunTime = item.lastRunTime || '-'
        if (lastRunTime && lastRunTime.length > 16) {
          lastRunTime = lastRunTime.replace(/-/g, '/').replace('T', ' ')
        }

        let nextRunTime = item.nextRunTime || '-'
        if (nextRunTime && nextRunTime.length > 16) {
          nextRunTime = nextRunTime.replace(/-/g, '/').replace('T', ' ')
        }

        return {
          id: item.id,
          title: item.name || '未命名任务',
          desc: item.triggerMessage || item.name || '任务配置',
          agent: item.agentName || '-',
          lastTime: lastRunTime,
          nextTime: nextRunTime,
          status: statusText,
          statusClass: statusClass,
          enabled: item.enabled || false,
          type: type,
          iconClass: iconClass,
          cronExpression: item.cronExpression,
          taskType: item.taskType,
          createdAt: item.createTime,
          updatedAt: item.updateTime,
          source: item.source || '',
          reportConfig: item.reportConfig || ''
        }
      })
    },
    transformData(data) {
      return data.map((item) => {
        let statusText = '已完成'
        let statusClass = 'status-completed'
        let iconClass = 'icon-blue'
        let type = 'ceo'

        if (item.status === 'running') {
          statusText = '执行中'
          statusClass = 'status-running'
        } else if (item.status === 'failed') {
          statusText = '失败'
          statusClass = 'status-pending'
        }

        if (item.agentName) {
          if (item.agentName.includes('CFO')) {
            iconClass = 'icon-orange'
            type = 'cfo'
          } else if (item.agentName.includes('CSO')) {
            iconClass = 'icon-green'
            type = 'cso'
          } else if (item.agentName.includes('指标')) {
            iconClass = 'icon-blue'
            type = 'indicator'
          } else if (item.agentName.includes('本体')) {
            iconClass = 'icon-blue'
            type = 'governance'
          } else if (item.agentName.includes('决策')) {
            iconClass = 'icon-blue'
            type = 'decision'
          } else {
            iconClass = 'icon-blue'
            type = 'ceo'
          }
        }

        let startedAt = item.startedAt || '-'
        if (startedAt && startedAt !== '-') {
          startedAt = startedAt.replace(/-/g, '/').replace('T', ' ')
        }

        let finishedAt = item.finishedAt || '-'
        if (finishedAt && finishedAt !== '-') {
          finishedAt = finishedAt.replace(/-/g, '/').replace('T', ' ')
        }

        return {
          id: item.id,
          cronJobId: item.cronJobId,
          title: item.jobName || '未命名任务',
          desc: item.triggerMessage || item.agentName || '任务已执行',
          agent: item.agentName || '-',
          startedAt: startedAt,
          finishedAt: finishedAt,
          status: statusText,
          statusClass: statusClass,
          enabled: item.status !== 'failed',
          type: type,
          iconClass: iconClass,
          conversationId: item.conversationId,
          createdAt: item.createTime
        }
      })
    },
    handleSearch() {
      this.fetchJobHistory()
    },
    handleExecutorChange(key) {
      this.activeExecutor = key
      if (this.activeTab === 'history') {
        this.fetchJobHistory()
      } else {
        this.fetchJobList()
      }
    },
    getCurrentAgentId() {
      if (this.activeExecutor === 'all') return null
      const executor = this.executorList.find((e) => e.key === this.activeExecutor)
      return executor ? executor.agentId : null
    },
    async fetchAgentList() {
      try {
        const res = await getAgentListApi()
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          const allList = res.data || []
          this.agentList = allList
            .filter(item => {
              const name = item.name || item.agentName || ''
              const sid = item.id || item.agentId || ''
              const sname = item.agentName || ''
              return name.includes('数字人') || sid.includes('shu_zi_ren') || sname.includes('shu_zi_ren')
            })
            .map(item => ({
              key: item.agentId || item.id,
              name: item.name || item.agentName || item.id,
              agentId: item.agentId || item.id
            }))
          if (this.agentList.length === 0) {
            this.agentList = this.getDefaultAgentList()
          }
        }
      } catch (e) {
        console.error('获取数字人列表失败:', e)
        this.agentList = this.getDefaultAgentList()
      }
    },
    getDefaultAgentList() {
      return [
        { key: AGENT_ID_MAP.ceo_shu_zi_ren, name: 'CEO数字人', agentId: AGENT_ID_MAP.ceo_shu_zi_ren },
        { key: AGENT_ID_MAP.cai_wu_shu_zi_ren, name: 'CFO数字人', agentId: AGENT_ID_MAP.cai_wu_shu_zi_ren },
        { key: AGENT_ID_MAP.gong_ying_lian_shu_zi_ren, name: 'CSO数字人', agentId: AGENT_ID_MAP.gong_ying_lian_shu_zi_ren }
      ]
    },
    handleToggleExpand(index) {
      const idx = this.expandedIndexes.indexOf(index)
      if (idx > -1) {
        this.expandedIndexes.splice(idx, 1)
      } else {
        this.expandedIndexes.push(index)
      }
    },
    onCronPeriodChange() {
      this.cronMinute = 0
      this.cronHour = 9
      this.cronMonthDay = 1
      this.cronMonth = 1
      this.cronQuarterStart = 1
    },
    parseCronExpression(expr) {
      if (!expr) {
        this.cronPeriod = 'daily'
        this.cronMinute = 0
        this.cronHour = 9
        this.cronMonthDay = 1
        this.cronMonth = 1
        this.cronQuarterStart = 1
        return
      }
      const parts = expr.trim().split(/\s+/)
      if (parts.length < 5) {
        this.cronPeriod = 'daily'
        return
      }
      const [minute, hour, day, month, week] = parts

      this.cronMinute = parseInt(minute) || 0
      this.cronHour = parseInt(hour) || 9
      this.cronMonthDay = parseInt(day) || 1
      this.cronMonth = parseInt(month) || 1

      if (day === '*' && month === '*' && week === '?') {
        this.cronPeriod = 'daily'
      } else if (month === '*' && week === '?') {
        this.cronPeriod = 'monthly'
      } else if (month.includes(',') && week === '?') {
        this.cronPeriod = 'quarterly'
        const firstMonth = parseInt(month.split(',')[0]) || 1
        this.cronQuarterStart = [1, 4, 7, 10].includes(firstMonth) ? firstMonth : 1
      } else if (week === '?') {
        this.cronPeriod = 'yearly'
        this.cronMonth = parseInt(month) || 1
      } else {
        this.cronPeriod = 'daily'
      }
    },
    handleViewDetail(task) {
      this.$emit('view-detail', task)
    },
    handleViewConfig(task) {
      this.$emit('view-config', task)
    },
    handleAddTask() {
      this.activeTab = 'config'
      this.editMode = true
      const currentAgent = this.$store?.state?.cosmoClaw?.currentAgentName
      const agentNameMap = {
        ceo_shu_zi_ren: 'CEO数字人',
        cai_wu_shu_zi_ren: 'CFO数字人',
        gong_ying_lian_shu_zi_ren: 'CSO数字人',
        zhi_biao_ding_yi_zhi_neng_ti: '指标定义智能体',
        ben_ti_zhi_li_zhi_neng_ti: '本体治理智能体',
        jing_ying_jue_ce_zhi_neng_ti: '经营决策智能体'
      }
      this.editForm = {
        id: '',
        title: '',
        agent: agentNameMap[currentAgent] || 'CEO数字人',
        taskType: '',
        cronExpression: '',
        enabled: true,
        content: '',
        source: '',
        reportType: 'market',
        category: 'internal',
        decision: false,
        decisionCondition: ''
      }
      this.cronPeriod = 'daily'
      this.cronMinute = 0
      this.cronHour = 9
      this.cronMonthDay = 1
      this.cronMonth = 1
      this.cronQuarterStart = 1
    },
    handleView(task) {
      this.$emit('view-task-detail', task)
    },
    handleEdit(task) {
      let reportType = 'market'
      let category = 'internal'
      let decision = false
      let decisionCondition = ''
      if (task.reportConfig) {
        try {
          const rc =
            typeof task.reportConfig === 'string'
              ? JSON.parse(task.reportConfig)
              : task.reportConfig
          reportType = rc.reportType || 'market'
          category = rc.category || 'internal'
          decision = rc.decision || false
          decisionCondition = rc.decisionCondition || ''
        } catch (e) {
          // ignore parse error
        }
      }
      this.activeTab = 'config'
      this.editMode = true
      this.editForm = {
        id: task.id || '',
        title: task.title || '',
        agent: task.agent || '',
        taskType: task.taskType || '',
        cronExpression: task.cronExpression || '',
        enabled: task.enabled !== undefined ? task.enabled : true,
        content: task.desc || '',
        source: task.source || '',
        reportType,
        category,
        decision,
        decisionCondition
      }
      this.parseCronExpression(task.cronExpression || '')
    },
    async handleSave() {
      if (!this.editForm.title) {
        this.$message.warning('请输入任务标题')
        return
      }
      if (!this.editForm.agent) {
        this.$message.warning('请选择执行者')
        return
      }
      if (!this.editForm.taskType) {
        this.$message.warning('请选择任务类型')
        return
      }
      if (!this.computedCronExpression) {
        this.$message.warning('请选择执行时间')
        return
      }
      if (!this.editForm.content) {
        this.$message.warning('请输入任务内容')
        return
      }
      if (!this.editForm.source) {
        this.$message.warning('请选择来源')
        return
      }

      const executor = this.executorList.find((e) => e.name === this.editForm.agent)
      const agentId = executor ? executor.agentId : (this.agentId || '')

      const data = {
        name: this.editForm.title,
        agentId: agentId,
        taskType: this.editForm.taskType || 'text',
        cronExpression: this.computedCronExpression || '',
        enabled: this.editForm.enabled,
        triggerMessage: this.editForm.content || '',
        source: this.editForm.source || 'manual'
      }

      if (this.editForm.taskType === 'report') {
        const rc = {
          reportType: this.editForm.reportType || 'market',
          category: this.editForm.category || 'internal',
          decision: this.editForm.decision || false
        }
        if (this.editForm.decision && this.editForm.decisionCondition.trim()) {
          rc.decisionCondition = this.editForm.decisionCondition.trim()
        }
        data.reportConfig = JSON.stringify(rc)
      }

      try {
        if (this.editForm.id) {
          await updateJobApi({ id: this.editForm.id, ...data })
          this.$message.success('更新成功')
        } else {
          await createJobApi(data)
          this.$message.success('创建成功')
        }
        this.editMode = false
        this.fetchJobList()
      } catch (error) {
        console.error('保存任务失败:', error)
      }
    },
    handleDelete(task) {
      this.$confirm('确定要删除该任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            await deleteJobApi(task.id)
            this.$message.success('删除成功')
            this.fetchJobList()
          } catch (error) {
            console.error('删除任务失败:', error)
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    async runTask(item) {
      this.runningTaskIds.add(item.id)
      try {
        const res = await runJobApi(item.id)
        if (res.code === 200 || res.code === '200' || res.code === 0) {
          this.$message.success('任务已触发执行')
          this.fetchJobList()
        }
      } catch (e) {
        console.error('执行任务失败:', e)
      } finally {
        this.runningTaskIds.delete(item.id)
      }
    },
    async handleToggle(task) {
      const newEnabled = task.enabled // v-model 已更新为最新值
      try {
        await toggleJobApi({ id: task.id, enabled: newEnabled })
        this.$message.success(newEnabled ? '启用成功' : '禁用成功')
      } catch (error) {
        console.error('切换任务状态失败:', error)
        task.enabled = !newEnabled
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-task-list";
.#{$class-prefix} {
  height: 100%;
  display: flex;
}
.list-container {
  display: flex;
  width: 100%;
  min-height: 500px;
}
.task-left-sidebar {
  width: 180px;
  background: #fafbfc;
  border-right: 1px solid #e8ecf0;
  padding: 16px;
}
.sidebar-title {
  font-size: 12px;
  color: #999;
  margin-bottom: 12px;
  font-family: PingFangSC-Regular;
}
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 4px;
  transition: all 0.2s;
  &:hover {
    background: #f0f2ff;
  }
  &.active {
    background: #4a5ff3;
    .item-count,
    .item-label {
      color: #fff;
    }
  }
}
.item-icon {
  font-size: 14px;
}
.item-label {
  flex: 1;
  font-size: 13px;
  color: #333;
  font-family: PingFangSC-Regular;
}
.item-count {
  font-size: 12px;
  color: #999;
  font-family: PingFangSC-Regular;
}
.main-content {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  // padding: 20px 0;
  // background: #fff;
}
.task-list {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.task-list::-webkit-scrollbar {
  width: 4px;
}
.task-list::-webkit-scrollbar-track {
  background: transparent;
}
.task-list::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #999;
  font-size: 14px;
}
.header-tabs {
  display: flex;
  gap: 10px;
  // margin-bottom: 16px;
}
.tabs_split {
  height: 32px;
  background-image: linear-gradient(180deg, #ffffff82 0%, #ffffff00 100%);
  border-radius: 0 8px 0 0;
  border-radius: 0 8px 0 0;
}
.tab {
  font-size: 14px;
  color: #595959;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  // padding-bottom: 4px;
  // border-bottom: 2px solid transparent;
  transition: all 0.2s;
  height: 40px;
  background-image: linear-gradient(0deg, #ffffff00 0%, #f7f8fc 100%);
  border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.active {
    color: #4a5ff3;
    background: #ffffff;
    // font-weight: 600;
    // border-bottom-color: #4A5FF3;
  }
}
.search-container {
  padding: 20px;
  background: #fff;
  border-radius: 0 8px 8px 8px;
  margin-bottom: 32px;
}
.search-area {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}
.search-input {
  flex: 1;
  width: 300px;
}
.filter-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  // margin-bottom: 16px;
  // padding: 12px 16px;
  // background: #FAFBFC;
  border-radius: 8px;
}
.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-label {
  font-size: 12px;
  color: #666;
  font-family: PingFangSC-Regular;
}
.filter-tabs {
  display: flex;
  gap: 8px;
}
.filter-tab {
  padding: 4px 16px;
  border-radius: 4px;
  height: 32px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  background: #f8f8f8;
  border: 1px solid transparent;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &.active {
    color: #4a5ff3;
    background: #edf1fb;
    border: 1px solid #4a5ff3;
  }
}
.edit-panel {
  // background: #FAFBFC;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #eee transparent;
}
.edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.edit-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  font-family: PingFangSC-Medium;
}
.edit-close {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  color: #999;
  transition: all 0.2s;
  &:hover {
    background: #f0f2ff;
    color: #4a5ff3;
  }
}
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  font-family: PingFangSC-Medium;
}
.required {
  color: #f56c6c;
  margin-right: 2px;
}
.form-input {
  width: 400px;
}
.form-textarea {
  width: 400px;
}
.form-select {
  width: 400px;
}
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}
.form-radio-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.form-radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #374151;
}
.form-radio {
  margin: 0;
  width: 14px;
  height: 14px;
}
.form-radio-label {
  font-size: 13px;
  color: #374151;
}
.cron-selects {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.cron-select-label {
  font-size: 13px;
  color: #64748b;
}
.cron-sel {
  width: 100px;
}
.cron-select-sep {
  font-size: 16px;
  color: #94a3b8;
  font-weight: 600;
}
.cron-preview {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #f8fafc;
  border-radius: 6px;
  width: fit-content;
}
.cron-preview-label {
  font-size: 11px;
  color: #94a3b8;
}
.cron-preview-value {
  font-size: 12px;
  color: #4a5ff3;
  font-family: "Courier New", monospace;
  font-weight: 500;
}
.task-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.history-item {
  padding: 18px 20px;
  background: #fff;
  border-radius: 8px;
  // border: 1px solid #E8ECF0;
}
.history-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.history-card-left {
  display: flex;
  align-items: flex-start;
  gap: 21px;
  width: calc(100% - 120px);
}
.history-card-right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.history-card-footer {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}
.task-icon-wrap {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  &.icon-blue {
    background: #eef4ff;
    color: #4a5ff3;
    i {
      font-size: 18px;
    }
  }
  &.icon-orange {
    background: #fff8e1;
    color: #ff9800;
    i {
      font-size: 18px;
    }
  }
  &.icon-green {
    background: #e8f5e9;
    color: #4caf50;
    i {
      font-size: 18px;
    }
  }
}
.task-info {
  flex: 1;
  min-width: 0;
}
.task-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  font-family: PingFangSC-Medium;
}
.task-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 8px;
  font-family: PingFangSC-Regular;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.task-meta {
  font-size: 12px;
  color: #999;
  font-family: PingFangSC-Regular;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.meta-divider {
  color: #ccc;
}
.task-status {
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.status-running {
    background: #edf1fb;
    color: #4a5ff3;
  }
  &.status-pending {
    background: #fef7ec;
    color: #f4b13d;
  }
  &.status-completed {
    background: #f1f8ed;
    color: #73b950;
  }
}
.expand-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
  i {
    transition: transform 0.2s;
  }
  &.expanded i {
    transform: rotate(180deg);
  }
  // &:hover {
  //   background: #F0F2FF;
  //   color: #4A5FF3;
  // }
}
.history-card-content {
  padding-left: 64px;
  padding-top: 12px;
  margin-top: 12px;
  // border-top: 1px dashed #E8ECF0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.content-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.row-label {
  font-size: 12px;
  color: #999;
  font-family: PingFangSC-Regular;
  flex-shrink: 0;
  width: 70px;
}
.row-value {
  font-size: 12px;
  color: #666;
  font-family: PingFangSC-Regular;
  flex: 1;
}
.action-btn {
  // padding: 8px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  transition: all 0.2s;
  width: 108px;
  height: 32px;
  background: #edf1fb;
  border: 1px solid #4a5ff3;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
  &.primary {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #4a5ff3;
  }
  &.secondary {
    background: #fff;
    color: #666;
    border: 1px solid #e8ecf0;
    &:hover {
      background: #f0f2ff;
      border-color: #4a5ff3;
      color: #4a5ff3;
    }
  }
}
.config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin-bottom: 12px;
  padding: 0 2px;
}
.config-count {
  font-size: 12px;
  color: #999;
  font-family: PingFangSC-Regular;
}
.add-task-btn {
  padding: 8px 20px;
  background: #4a5ff3;
  border-radius: 6px;
  cursor: pointer;
  border: none;
  color: #fff;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 500;
  transition: all 0.2s;
  &:hover {
    background: #3d52d5;
  }
  &:active {
    transform: scale(0.98);
  }
}
.config-item {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 18px 24px;
  background: #fff;
  border-radius: 8px;
  height: 80px;
  // border: 1px solid #E8ECF0;
}
.config-icon-wrap {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
  &.icon-blue {
    background: #eef4ff;
    color: #4a5ff3;
    i {
      font-size: 16px;
    }
  }
  &.icon-orange {
    background: #fff8e1;
    color: #ff9800;
    i {
      font-size: 16px;
    }
  }
  &.icon-green {
    background: #e8f5e9;
    color: #4caf50;
    i {
      font-size: 16px;
    }
  }
}
.config-info {
  flex: 1;
  min-width: 0;
}
.config-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-family: PingFangSC-Medium;
}
.config-meta {
  font-size: 12px;
  color: #595959;
  font-family: PingFangSC-Regular;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
}
.config-status {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
  flex-shrink: 0;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.status-running {
    background: #edf1fb;
    color: #4a5ff3;
  }
  &.status-pending {
    background: #fef7ec;
    color: #f4b13d;
  }
  &.status-completed {
    background: #f1f8ed;
    color: #73b950;
  }
}
.config-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.config-action-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #f0f2ff;
    color: #4a5ff3;
  }
}
.config-action-disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
